import React from 'react';
import { Row } from 'antd';
import { Button } from './style';

interface LinkOptionProps {
  id: string;
  name: string;
  // eslint-disable-next-line no-unused-vars
  onClick: (id: string, name: string) => void;
}

const LinkOption = function ({ id, name, onClick }: LinkOptionProps) {
  return (
    <Row justify="center" style={{ marginTop: '5px' }}>
      <Button
        type="link"
        onClick={() => onClick(id, name)}
      >
        {name}
      </Button>
    </Row>
  );
};

export default LinkOption;
